
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';
import { Country } from '../../../models/backend-definitions.module';

@Injectable()
export class CountryEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    country: Country;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getCountry()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCountry(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('country/' + this.routeParams.id).subscribe((res: Country ) => {
                    this.country = res;
                    this.onDataChanged.next(this.country);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(country): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('country/', country).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(country): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('country/', country).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(country): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('country/' + country.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
